import { StringObject } from "../../objects/StringObject";

type HoverState = { enter?: () => void; leave?: () => void };

export class HoverTracker {
  private active = new Set<StringObject>();
  private subs = new WeakMap<StringObject, HoverState>();

  track(obj: StringObject) {
    if (this.subs.has(obj)) return;
    const el = obj.htmlElement;

    const enter = () => this.active.add(obj);
    const leave = () => this.active.delete(obj);

    el.addEventListener("pointerenter", enter);
    el.addEventListener("pointerleave", leave);
    this.subs.set(obj, { enter, leave });
  }

  untrack(obj: StringObject) {
    const st = this.subs.get(obj);
    if (!st) return;
    const el = obj.htmlElement;
    if (st.enter) el.removeEventListener("pointerenter", st.enter);
    if (st.leave) el.removeEventListener("pointerleave", st.leave);
    this.active.delete(obj);
    this.subs.delete(obj);
  }

  isActive(obj: StringObject) {
    return this.active.has(obj);
  }
  activeObjects(): StringObject[] {
    return Array.from(this.active);
  }
}
